$(document).ready(function () {
    window.alertSuccess = function (msg) {
        swal.fire({
            position: 'center',
            icon: "success",
            title: msg,
            showConfirmButton: false,
            timer: 1500,
            iconColor: '#FF5001',
        })
    }

    window.alertSuccessWithBtn = function (msg) {
        swal.fire({
            position: 'center',
            icon: "success",
            title: msg,
            showConfirmButton: true,
            confirmButtonText: 'OK',
            confirmButtonColor: '#ff0000',
            iconColor: '#FF5001',
        })
    }

    window.alertError = function (msg) {
        swal.fire({
            confirmButtonColor: "#eb0c0c",
            position: 'center',
            icon: "error",
            title: msg,
            showConfirmButton: true,
        })
    }


    window.alertSuccessAlmadia = function (msg) {
        swal.fire({
            position: 'center',
            icon: "success",
            title: msg,
            showConfirmButton: false,
            timer: 1500,
            iconColor: '#45ec0d',
        })
    }

    window.alertErrorAlmadia = function (msg) {
        swal.fire({
            confirmButtonColor: "#eb0c0c",
            position: 'center',
            icon: "error",
            title: msg,
            showConfirmButton: true,
        })
    }


    window.responseAlert = function (data) {
        console.log(data);
        swal.fire({
            title: data.title,
            text: data.message,
            icon: data.icon,
        }).then((result) => {
            //$('.btn-pay').prop("disabled", false);
            if (data.url !== '') {
                if (data.target == 'Y') {
                    window.open(data.url, '_blank');
                    setTimeout(function () {
                        window.location.href = window.location.origin + "/mis-pedidos";
                    }, 400);
                } else {
                    //checar esto ya no me acuerdo para que lo puse iordaz
                    if (data.order == 'Y') {
                        window.location.href = window.location.origin + "/mis-pedidos";
                    }
                }
            }
        });
    }


    window.msj_rollback = function () {
        swal.fire({
            title: 'Advertencia',
            text: 'Ocurrió un problema.',
            icon: 'error',
            confirmButtonColor: '#003b5a',
        }).then((result) => {
            //$('.btn-pay').prop("disabled", false);
        });
    }

});
